"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawImage = exports.drawLoadingAnimation = exports.isValidImage = exports.adjustScale = exports.sizeImage = void 0;
function sizeImage(imageWidth, imageHeight, canvasWidth, canvasHeight) {
    const imageAspectRatio = imageWidth / imageHeight;
    const canvasAspectRatio = canvasWidth / canvasHeight;
    // Size the image to cover the canvas completely.
    const width = imageAspectRatio > canvasAspectRatio
        ? canvasHeight * imageAspectRatio
        : canvasWidth;
    const height = imageAspectRatio > canvasAspectRatio
        ? canvasHeight
        : canvasWidth / imageAspectRatio;
    // Center the image on the canvas.
    const x = (canvasWidth - width) / 2;
    const y = (canvasHeight - height) / 2;
    // Final image position and size.
    return { x, y, width, height };
}
exports.sizeImage = sizeImage;
function adjustScale(context) {
    return context.canvas.clientWidth
        ? context.canvas.width / context.canvas.clientWidth
        : 1;
}
exports.adjustScale = adjustScale;
/**
 * Whether an image or canvas element are valid.
 */
function isValidImage(image) {
    return !!image && image.width > 0 && image.height > 0;
}
exports.isValidImage = isValidImage;
/**
 * Draw an animation
 */
function drawLoadingAnimation(context, rectangle) {
    const elapsedTime = Date.now();
    const gradientWidth = rectangle.width / 3;
    // How long it takes to move the gradient across the image placeholder.
    const animationDuration = 1200;
    // Pause after each animation loop.
    const pauseDuration = 500;
    const framePercentage = elapsedTime % (animationDuration + pauseDuration);
    context.fillStyle = '#E5E5E5';
    context.fillRect(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    if (framePercentage <= animationDuration) {
        // Starting x coord of the gradient. At the start of the animation,
        // the gradient is to the left of the pic frame and not visible.
        // It then slides into the picture frame going left to right.
        // Only the part inside the picture frame is visible.
        const gradientX = rectangle.x - gradientWidth + (rectangle.width + gradientWidth) *
            framePercentage / animationDuration;
        const gradient = context.createLinearGradient(gradientX, 0, gradientX + gradientWidth, 0);
        gradient.addColorStop(0, '#E5E5E5');
        gradient.addColorStop(0.5, '#D9D9D9');
        gradient.addColorStop(1, '#E5E5E5');
        context.fillStyle = gradient;
        if (gradientX < rectangle.x + rectangle.width) {
            // We don't want to show the part of the gradient that is to the
            // left of the picture frame, the x coordinate has to be at least
            // the picture frame's x-coord.
            const x = Math.max(rectangle.x, gradientX);
            // Similarly, we dont want to show the part of the gradient that
            // is to the right of the picture frame.
            let width = Math.min(gradientWidth, rectangle.width + rectangle.x - gradientX);
            // If the gradient x-coord is to the left of the picture frame,
            // then the width is equal to the length of the gradient that
            // overlaps with the picture frame.
            if (gradientX - rectangle.x < 0) {
                width = gradientWidth + (gradientX - rectangle.x);
            }
            context.fillRect(x, rectangle.y, width, rectangle.height);
        }
    }
}
exports.drawLoadingAnimation = drawLoadingAnimation;
/**
 * Draws the image with integer valued sourceX and sourceY in a cross compatible way.
 * This is done by recalculating the values such that they are always non negative.
 * Assumes width and height for either source and destinations are always positive.
 */
function drawImage(context, image, sourceX, sourceY, sourceWidth, sourceHeight, destinationX, destinationY, destinationWidth, destinationHeight) {
    const correctedSourceX = Math.max(0, sourceX);
    const correctedSourceY = Math.max(0, sourceY);
    const correctedSourceWidth = Math.min(sourceWidth, sourceWidth + sourceX, image.width - correctedSourceX);
    const correctedSourceHeight = Math.min(sourceHeight, sourceHeight + sourceY, image.height - correctedSourceY);
    // Skip drawing an empty image.
    if (correctedSourceWidth <= 0 || correctedSourceHeight <= 0) {
        return;
    }
    const correctedWidthRatio = Math.min(sourceWidth, sourceWidth + sourceX) / sourceWidth;
    const correctedHeightRatio = Math.min(sourceHeight, sourceHeight + sourceY) / sourceHeight;
    const correctedDestinationX = destinationX + destinationWidth - destinationWidth * correctedWidthRatio;
    const correctedDestinationY = destinationY + destinationHeight - destinationHeight * correctedHeightRatio;
    const correctedDestinationWidth = destinationWidth * correctedSourceWidth / sourceWidth;
    const correctedDestinationHeight = destinationHeight * correctedSourceHeight / sourceHeight;
    context.drawImage(image, correctedSourceX, correctedSourceY, correctedSourceWidth, correctedSourceHeight, correctedDestinationX, correctedDestinationY, correctedDestinationWidth, correctedDestinationHeight);
}
exports.drawImage = drawImage;
